import { FC, useState } from 'react';
import { createUser } from 'actions/userActions';
import { withRouter, useHistory } from 'react-router-dom';
import styles from './signUpForm.module.scss';
import TextField from 'components/UI/textField/textField';
import { Button } from 'components/UI/button/button';
import { RoutePaths } from 'app/routing/routing';
import { useForm } from 'react-hook-form';

export interface SignUpFormFields {
  email: string;
  password: string;
  passwordConfirmation: string;
}

export const SignUpFormComponent : FC = () => {
  const { register, handleSubmit, formState: { errors }, watch } = useForm<SignUpFormFields>();
  const history = useHistory();

  const [signUpError, setSignUpError] = useState<string | null>(null);

  const onSubmit = async (values: SignUpFormFields) => {
    setSignUpError(null);
    try {
      await createUser(values);
      history.push(RoutePaths.Login);
    } catch (err: any) {
      if (err?.status === 400) {
        setSignUpError('A user for the provided email address already exists');
      } else {
        setSignUpError(`There was an error creating the user. Please try again later.`);
      }
    }
  };
  
  return (
    <form onSubmit={handleSubmit(onSubmit)} >
      <TextField id="email" register={register} type="email" placeholder="Email" label="Email" className={styles.field} labelClassName={styles.labels} errors={errors} validationSchema={{ 
        required: "Email is required",
        pattern: {
          value: /\S+@\S+\.\S+/,
          message: "Entered value does not match email format",
        }
      }} />
      <TextField id="password" register={register} type="password" placeholder="Password" label="Password" className={styles.field} labelClassName={styles.labels} errors={errors} validationSchema={{ 
        required: "Password is required",
        pattern: {
          value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          message: "Password must have an upper case letter, lower case letter, special character, a numberm and be at least 8 characters",
        }
      }} />
      <TextField id="passwordConfirmation" register={register} type="password" placeholder="Confirmation Password" label="Confirmation Password" className={styles.field} labelClassName={styles.labels} errors={errors} validationSchema={{ 
        required: "Confirmation Password is required",
        validate: (val: string) => {
          if (watch('password') != val) {
            return "Your passwords do no match";
          }
        }
      }} />
      <Button className={styles.submitButton} type="submit">
            Submit
      </Button>
      {signUpError && <div>{signUpError}</div>}
    </form>
  );
};

export const SignUpForm = withRouter(SignUpFormComponent);
